import { Alert } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { Fragment, useCallback, useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-switch-lang';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import Breadcrumb from '../../../../breadcrumb';
import styles from '../../../../styles/style-setting.module.scss';
import CreateActivity from '../create-country/create-country';
import EditCountry from '../edit-country/edit-country';
import ActivityColumns from './table-header/activity-columns';

// number of activities per page
const NUMBER_OF_COUNTRIES_PER_PAGE = 15;

const ListActivityPage = (props) => {
  const [countries, setCountries] = useState([]);
  const httpClient = useHttpClient(true);
  const [pageNumber, setPageNumber] = useState(0);
  const activityPerPage = NUMBER_OF_COUNTRIES_PER_PAGE;
  const keycloak = useKeycloak().keycloak;
  const [role, setRole] = useState('');
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);

  const [spinner, setSpinner] = useState({ state: false, id: '' });

  const getCountries = useCallback(() => {
    httpClient.current?.get(`/api/country/all`).then((response) => {
      setCountries(response.data);
    });
  }, [httpClient]);

  const buildData = (newCountries, searchCriteria) => {
    const pagesVisited = pageNumber * NUMBER_OF_COUNTRIES_PER_PAGE;
    const restPagination = newCountries
      .filter((activity) => activity.name.toUpperCase().includes(searchCriteria.toUpperCase()))
      .slice(pagesVisited, pagesVisited + activityPerPage);
    const newData = restPagination.map((country) => {
      let action = (
        <div>
          <span>
            <EditCountry country={country} countries={getCountries} />
          </span>
          <span>
            <DeleteButtonIcon
              title={props.t('delete_country')}
              onClick={() =>
                SweetAlert.fire({
                  title: props.t('you_delete'),
                  text: props.t('not_recover'),
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: props.t('cancel'),
                  reverseButtons: true,
                }).then((result) => {
                  if (result.value) {
                    deleteCountry(country.id);
                    SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                  } else {
                    SweetAlert.fire(props.t('isNotDeleted'));
                  }
                })
              }
              className={`fa fa-trash ${styles['trash']}`}
            />
          </span>
        </div>
      );
      let status =
        spinner.state === true && spinner.id === country.id ? (
          <div className={`loader-box  ${styles['spinner']}`}>
            <div className="loader-2"></div>
          </div>
        ) : (
          <input
            type="checkbox"
            disabled={role === 'admin'}
            name="status"
            checked={country?.valid}
            onChange={(e) => handleCheckBox(e, country)}
          />
        );

      return {
        id: country.id,
        name: country.name,
        status: status,
        action: action,
      };
    });
    setData(newData);
  };

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const deleteCountry = async (countryId) => {
    await httpClient.current?.delete(`/api/country/${countryId}`);
    getCountries();
  };

  const handleCheckBox = async (event, activity) => {
    setSpinner({ state: true, id: activity.id });
    const activityValidation = { id: activity.id, name: activity.name, valid: event.target.checked };
    const response = httpClient.current?.put(`/api/country/update`, activityValidation);
    if ((await response).status === 200) {
      getCountries();
      setSpinner({ state: false, id: activity.id });
    }
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setPageNumber(0);
  };

  useEffect(() => {
    getCountries();

    if (keycloak.authenticated) {
      keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER')
        ? setRole('super admin')
        : keycloak.hasResourceRole('ROLE_AGRISED_ADMIN')
        ? setRole('admin')
        : setRole('user');
    }
  }, [getCountries, keycloak]);

  useEffect(() => {
    buildData(countries, search);
  }, [countries, search, pageNumber]);

  const pageCount = Math.ceil(
    (search === '' ? countries : countries.filter((activity) => activity.name.includes(search))).length /
      activityPerPage
  );
  
  return (
    <div>
      <Fragment>
        <Breadcrumb parent={props.t('country_url')} url={'settings/country'} />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <div className="float-right">
                    <CreateActivity countries={getCountries} />
                  </div>
                </CardHeader>
                <CardBody>
                  <input
                    className="form-control col-md-6 mb-2 "
                    onChange={handleSearch}
                    value={search}
                    placeholder={props.t('search_country')}
                  />
                  {data.length === 0 ? (
                    <Alert variant="outlined" severity="info">
                      {props.t('no_country')}
                    </Alert>
                  ) : (
                    <ActivityColumns data={data} />
                  )}
                  <br />
                  <div className="float-right">
                    {countries.length > NUMBER_OF_COUNTRIES_PER_PAGE && (
                      <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={styles['paginationButton']}
                        previousLinkClassName={styles['previousBtn']}
                        nextLinkClassName={styles['nextBtn']}
                        disabledClassName={styles['paginationDisabled']}
                        activeClassName={styles['paginationActive']}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </div>
  );
};
export default translate(ListActivityPage);
